export default {
  contained: {
    backgroundColor: '#DC9B14',
    borderRadius: 25,
    fontSize: 13,
    color: '#FFF',
    fontWeight: 700,
    textTransform: 'uppercase',
    padding: '6px 15px',
    cursor: 'pointer',
    letterSpacing: '0.07em',
    boxShadow:
      '0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20)',
    "&:hover": {
        backgroundColor: "#bb8109",
    }
  }
};
 